import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
    selector: 'app-userrole',
    templateUrl: './userrole.component.html',
    styleUrls: ['./userrole.component.css']
})
export class UserroleComponent implements OnInit, OnDestroy {
    displayed = true;
    selected: number;
    columnDefinitions: Column[];
    clients: any[];
    roles: any[];
    clientSelected: number;
    roleSelected: number;

    show: boolean;
    dataset: any[];
    totalData: number;
    selectedTitles: any[];
    private respObject: any;
    private roleName: any;
    private clientName: any;
    displayData: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    private clientId: number;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private adminAuth: Subscription;
    private baseFlag: any;
    offset: number;
    dataLoaded: boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    roleSelecte: any;
    role: any;
    name: string;

    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {

                    }
                    break;
                case 'delete':
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteClientUserRole({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
    }


    ngOnInit() {
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Client  Mapping with Role',
            openModalButton: 'Add Client Role Map',
            searchModalButton: 'Search',
            breadcrumb: 'ClientRoleMap',
            folderName: 'All Client Role Map',
            tabName: 'Client Role Map'
        };

        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'roledesc', name: 'Role', field: 'role', sortable: true, filterable: true
            },
            {
                id: 'clientname', name: 'Client Name', field: 'client', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        this._rest.getClient().subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                this.clients = this.respObject.clients;
                this.clientSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, function (err) {

        });

        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
    }

    onPageLoad() {
        this._rest.getRoleClientWise(this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.roles.unshift({id: 0, name: 'Select Role'});
                this.roles = this.respObject.roles;
                this.roleSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        });
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.roleSelected = 0;
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    searchModal(scarch_content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.roleSelected = 0;
            this.name = '';
            this.roleSelecte = '';
            this.modalService.open(scarch_content).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    getDetails() {
        for (let i = 0; i < this.role.length; i++) {
            if (this.role[i].role === this.roleSelecte) {
                this.name = this.role[i].client;
            }
        }
    }

    search() {
        this._rest.searchAllRoleMapping(this.roleSelecte, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.role = this.respObject.details;
                this.messageService.setTotalData(this.role.length);
                this.messageService.setGridData(this.role);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    save() {
        const data = {
            clientId: this.clientSelected, roleId: this.roleSelected, createdBy: this.messageService.getUserId()
        };
        if (!this.messageService.isBlankField(data)) {
            this._rest.mapRoleWithClient(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    this.isError = false;
                    const id = this.respObject.id;
                    this.messageService.setRow({id: id, role: this.roleName, client: this.clientName});
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    this.roleSelected = 0;
                    this.clientSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = err;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getMappedRoleWithClient(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.roles.totalData[0].count;
                this.totalPage = respObject.roles.totalPage;
            }
            if (!this.isEmpty(respObject.roles.dataObj)) {
                const data = respObject.roles.dataObj;
                this.nextOffset = respObject.roles.nextOffset;
                this.offset = respObject.roles.nextOffset;
                this.previousOffset = respObject.roles.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.roles.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.roles.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onClientChange(index: any) {
        this.clientName = this.clients[index].name;
    }

    onRoleChange(index: any) {
        this.roleName = this.roles[index].name;
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
